import { useTranslation } from "react-i18next";

const Banner = () => {
    const { t } = useTranslation('common');

    return (
        <div className="container w-full flex flex-col gap-[35px]">
            <div className="flex w-full gap-[30px] xlx:gap-[50px] items-start justify-center lg:flex-row flex-col">
                <div className="flex flex-col gap-[4px] xs:min-w-[332px] mt-[2px]">
                    <h5 className="text-blackDull dark:text-textBlackDull font-bold uppercase">{t("corporate.content_pages.about_us.title")}</h5>
                    <h1 className="text-blackDull dark:text-textBlackDull font-bold max-w-[400px] lg:max-w-[550px]">{t("corporate.content_pages.about_us.subtitle")}</h1>
                </div>

                <div className="flex flex-col gap-[18px] w-full">
                    <h5 className="text-blackDull dark:text-textBlackDull font-semibold text-justify">{t("corporate.content_pages.about_us.line1")}</h5>

                    <h5 className="text-blackDull dark:text-textBlackDull font-semibold text-justify">{t("corporate.content_pages.about_us.line2")}</h5>

                    <h5 className="text-blackDull dark:text-textBlackDull font-semibold text-justify">{t("corporate.content_pages.about_us.line3")}</h5>

                    <h5 className="text-blackDull dark:text-textBlackDull font-semibold text-justify">{t("corporate.content_pages.about_us.line4")}</h5>

                    <h5 className="text-blackDull dark:text-textBlackDull font-semibold text-justify">{t("corporate.content_pages.about_us.line5")}</h5>
                </div>
            </div>

            <div className="w-full flex items-center justify-center">
                <img src={require('../../../../assets/images/about-us.png')} alt="about-us" />
            </div>
        </div>
    );
};

export default Banner;